/** Everything from the first `?` or `#` on. */
const QUERY_AND_FRAGMENT = /[?#].*$/;

const HASH_PREFIX = /^#/;

/**
 * Page location reported to Google Analytics: the route path only. Query
 * strings and fragments carry task ids, field names and other user data that
 * must not reach it.
 */
export function pageLocationOf(routeUrl: string): string {
  return routeUrl.replace(QUERY_AND_FRAGMENT, '');
}

/**
 * `pageLocationOf` the route in the address bar. The app routes by hash
 * (`#/route?query`), so the route is read from the hash when there is one.
 */
export function currentPageLocation(): string {
  const hashRoute = window.location.hash.replace(HASH_PREFIX, '');
  if (hashRoute) {
    return pageLocationOf(hashRoute);
  }
  return pageLocationOf(window.location.pathname);
}
